//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
    collection_slug: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/headline-carousel/{collection_slug} -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    action_template: t.string,
    bg_color: t.union([t.null, t.undefined, t.string]),
    btn_color: t.union([t.null, t.undefined, t.string]),
    btn_title: t.union([t.null, t.undefined, t.string]),
    carousel_type: t.string,
    category_id: t.union([t.null, t.undefined, t.string]),
    date_from: t.string,
    date_to: t.string,
    direct_link: t.union([t.null, t.undefined, t.string]),
    display_order: t.number,
    game_id: t.union([t.null, t.undefined, t.string]),
    id: t.number,
    img_url_desktop: t.union([t.null, t.undefined, t.string]),
    img_url_mobile: t.union([t.null, t.undefined, t.string]),
    img_url_tablet: t.union([t.null, t.undefined, t.string]),
    is_active: t.boolean,
    subtitle: t.string,
    tc_text: t.union([t.null, t.undefined, t.string]),
    title: t.string,
    universe: t.string,
}));
export type Response200Type = Array<{
    action_template: string;
    bg_color?: null | undefined | string;
    btn_color?: null | undefined | string;
    btn_title?: null | undefined | string;
    carousel_type: string;
    category_id?: null | undefined | string;
    date_from: string;
    date_to: string;
    direct_link?: null | undefined | string;
    display_order: number;
    game_id?: null | undefined | string;
    id: number;
    img_url_desktop?: null | undefined | string;
    img_url_mobile?: null | undefined | string;
    img_url_tablet?: null | undefined | string;
    is_active: boolean;
    subtitle: string;
    tc_text?: null | undefined | string;
    title: string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.unknown;
export type Response400Type = unknown;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.unknown;
export type Response401Type = unknown;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response404IO = t.unknown;
export type Response404Type = unknown;
export const decodeResponse404 = createGuard(404, Response404IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetHeadlineCarouselsRequest"
 */
export const openapi_website_cms_getHeadlineCarousels = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/headline-carousel/${params.collection_slug}${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetHeadlineCarouselsParamsType = ParamsType;

export type OpenapiWebsiteCmsGetHeadlineCarouselsResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 404;
    body: Response404Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetHeadlineCarouselsResponse200Type = Response200Type;

export const openapiWebsiteCmsGetHeadlineCarouselsRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetHeadlineCarouselsResponseType> => {
    const response = await openapi_website_cms_getHeadlineCarousels(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 404) {
        return { status: 404, body: decodeResponse404(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetHeadlineCarouselsRequest - unhandled response ${response.status}`);
};

